export default "__VITE_ASSET__jo5k1toN__"